import Vue from 'vue'
import i18n from '@ms/lang/i18n.js'
import Toast from './VToast.vue'

const ToastConstructor = Vue.extend(Toast)

/**
 * toast message
 * @param {String} message
 * @param {Object} options
 * @param {Number} options.duration
 * @param {Array} options.classNames
 * @param {Function} options.onClose
 * @param {String} options.type  regSuceess/success/info/error, 其中 success/info/error 只有 desktop 支持
 * @param {String} options.theme
 * @param {Boolean} options.closeable
 * @param {Boolean} options.dangerouslyUseHTMLString
 * @returns toast instance
 */
export default function toast(message, { duration, classNames = [], onClose, type, theme, closeable = false, dangerouslyUseHTMLString = false } = {}) {
  const ToastInstance = new ToastConstructor({
    i18n,
    data: {
      message,
      duration,
      classNames,
      onClose,
      type,
      theme,
      closeable,
      dangerouslyUseHTMLString
    }
  })

  const vm = ToastInstance.$mount()
  vm.visible = true
  document.body.appendChild(vm.$el)
  return vm
}
